import React, { Component } from "react";
import { Link as RouterLink, withRouter } from "react-router-dom";
import DocumentTitle from "react-document-title";
import Axios from "axios";
import * as qs from "query-string";
import { Button, withStyles } from "@material-ui/core";
import GenericApi from "Api";
import AuthLayout from "./AuthLayout";
import Spinner from "components/Spinner/Spinner";

const styles = {
  content: {
    textAlign: "center"
  },
  text: {
    padding: "20px 0"
  }
};

const AdapterLink = React.forwardRef((props, ref) => (
  <RouterLink innerRef={ref} {...props} />
));

export class EmailChangeComplete extends Component {
  state = {
    loading: true,
    success: false,
    error: null
  };

  componentDidMount() {
    const parsed = qs.parse(this.props.location.search);
    Axios.put(
      `${GenericApi.getBaseUrl()}/user/email_verify`,
      { token: parsed.token },
      { headers: { "Content-Type": "application/json" } }
    )
      .then(() => {
        this.setState({ loading: false, success: true });
      })
      .catch(error => {
        this.setState({
          loading: false,
          error: error.response?.data?.error || "An error occurred"
        });
      });
  }

  renderCoreContent = () => {
    const { classes } = this.props;
    const { loading, success, error } = this.state;

    if (loading) return <Spinner />;
    if (error) return <div className={classes.text}>{error}</div>;
    if (success)
      return (
        <>
          <div className={classes.text}>
            You've successfully changed your email address
          </div>
          <div>
            <Button
              variant="contained"
              color="primary"
              component={AdapterLink}
              to="/"
            >
              Continue
            </Button>
          </div>
        </>
      );
  };

  render() {
    const { classes } = this.props;

    return (
      <DocumentTitle title="Email change" test-data="EmailChangeComplete">
        <AuthLayout title="Confirmation">
          <div className={classes.content}>{this.renderCoreContent()}</div>
        </AuthLayout>
      </DocumentTitle>
    );
  }
}

export default withRouter(withStyles(styles)(EmailChangeComplete));
